<template>
    <div>
        <h2>403 Permission denied</h2>
    </div>
</template>

<script>
export default {

}
</script>
